import {Agency} from './agency';

export class User {
  constructor(public name: string,
              public agency: Agency) {

  }
}



// WEBPACK FOOTER //
// ./src/app/models/user.ts